export default "<h1 class=\"page-title\">Bourbon</h1>\n<whiskey-list [whiskeyList]=\"whiskeyList\"></whiskey-list>";